var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsOutlookDull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 787,
    height: 689,
    viewBox: "0 0 787 689",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_35509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197 295.286H738.062C765.229 295.286 787.25 317.319 787.25 344.5V639.786C787.25 666.967 765.229 689 738.062 689H246.188C219.022 689 197 666.967 197 639.786V295.286Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.625 0H295.125C267.959 0 245.938 22.034 245.938 49.2143V639.786C245.938 666.966 267.959 689 295.125 689H688.625C715.79 689 737.812 666.966 737.812 639.786V49.2143C737.812 22.034 715.79 0 688.625 0Z",
    fill: "#1066B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.625 0H295.125C267.959 0 245.938 22.034 245.938 49.2143V639.786C245.938 666.966 267.959 689 295.125 689H688.625C715.79 689 737.812 666.966 737.812 639.786V49.2143C737.812 22.034 715.79 0 688.625 0Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.875 73.8215H245.938V319.893H491.875V73.8215Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.875 319.893H245.938V565.964H491.875V319.893Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.812 319.893H491.875V565.964H737.812V319.893Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.812 73.8215H491.875V319.893H737.812V73.8215Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 689V344L197 689H787Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.75 689V344.5L811.594 689H196.75Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.5 123.036H49.1875C22.022 123.036 0 145.07 0 172.25V516.75C0 543.93 22.022 565.964 49.1875 565.964H393.5C420.665 565.964 442.688 543.93 442.688 516.75V172.25C442.688 145.07 420.665 123.036 393.5 123.036Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.312 346.205V342.113C344.312 271.225 293.335 221.464 221.733 221.464C149.742 221.464 98.375 271.565 98.375 342.795V346.887C98.375 417.775 149.352 467.536 221.344 467.536C292.946 467.536 344.312 417.436 344.312 346.205ZM286.33 346.887C286.33 393.919 259.87 422.207 221.733 422.207C183.597 422.207 156.746 393.237 156.746 346.205V342.113C156.746 295.082 183.208 266.793 221.344 266.793C259.09 266.793 286.33 295.763 286.33 342.795V346.887Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_35509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 787,
    height: 689,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsOutlookDull);
export default __webpack_public_path__ + "static/media/ms-outlook-dull.0e58eeced88b84282255ae5586bd4e7c.svg";
export { ForwardRef as ReactComponent };